import { LanguageToggle } from '@biniyog/localize';
import { Button, Drawer, Popover, Spin } from 'antd';
import { lazy, memo, Suspense, useCallback, useState } from 'react';
import { AiOutlineBars, AiOutlineDown, AiOutlineUp } from 'react-icons/ai';
import Biniyog from './Icons/Logo_Biniyog.webp';
import './index.scss';
import MobileNavHead from './MobileNav/Head';
import { NavPopOverContent } from './NavPopOverContent';

const MobileNav = lazy(() => import('./MobileNav'));

type Props = {
  hasTranslation?: boolean;
  overflowY?: 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto';
};

export const ExternalNavBar = memo(({ hasTranslation = false, overflowY = 'scroll' }: Props) => {
  const [isInvestPopoverOpen, setIsInvestPopoverOpen] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const popOverContent = (showCloseButton, onClose) => {
    return (
      <div
        style={{
          padding: '20px',
          position: 'relative',
        }}
      >
        <NavPopOverContent onClose={onClose} showCloseButton={showCloseButton} />
      </div>
    );
  };

  const onButtonClick = (e) => {
    document.location.href = 'https://platform.biniyog.com.bd/';
  };

  const onBrandButtonClick = (e) => {
    document.location.href = 'https://www.biniyog.com.bd/';
  };

  const onClose = useCallback(() => {
    setIsMobileNavOpen(false);
  }, []);

  const onPopoverVisibilityChange = useCallback((open: boolean) => setIsInvestPopoverOpen(open), []);

  const onMobileNavOpen = useCallback(() => setIsMobileNavOpen(true), []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div style={{ height: '80px', borderBottom: '2px solid #e7e7e7' }}>
        <div
          className="nav-container"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}
        >
          <div className="brand" onClick={onBrandButtonClick}>
            <img
              src={Biniyog}
              style={{ height: '68px', width: '213px', position: 'static', overflow: 'auto' }}
              alt=""
              loading="eager"
            />
          </div>

          <nav className="nav">
            <div className="nav-mobile">
              <Button type="text" onClick={onMobileNavOpen}>
                <AiOutlineBars
                  style={{
                    height: '30px',
                    width: '30px',
                    color: 'black',
                  }}
                />
              </Button>
              <Drawer
                headerStyle={{ padding: 0 }}
                title={
                  <div style={drawerTitleWrapperStyles}>
                    <MobileNavHead setIsMobileNavOpen={setIsMobileNavOpen} onBrandButtonClick={onBrandButtonClick} />
                  </div>
                }
                placement={'top'}
                closable={false}
                onClose={onClose}
                visible={isMobileNavOpen}
                key={'top'}
                bodyStyle={{ padding: 0 }}
                style={{ padding: 0, overflow: 'auto' }}
                className="ext-nav-bar"
                contentWrapperStyle={{ height: 'auto' }}
              >
                {isMobileNavOpen ? (
                  <Suspense fallback={<Spin />}>
                    <MobileNav
                      isMobileNavOpen={isMobileNavOpen}
                      setIsMobileNavOpen={setIsMobileNavOpen}
                      isInvestPopoverOpen={isInvestPopoverOpen}
                      setIsInvestPopoverOpen={setIsInvestPopoverOpen}
                      hasTranslation={hasTranslation}
                      onButtonClick={onButtonClick}
                      onBrandButtonClick={onBrandButtonClick}
                      onClose={onClose}
                    />
                  </Suspense>
                ) : (
                  ''
                )}
              </Drawer>
            </div>
            <ul className="nav-list">
              <li className="nav-list-item">
                <Popover content={popOverContent} placement="bottom" onVisibleChange={onPopoverVisibilityChange}>
                  <div className="invest">
                    <span>Invest &nbsp;</span>
                    {isInvestPopoverOpen ? (
                      <AiOutlineUp style={{ marginTop: 2 }} />
                    ) : (
                      <AiOutlineDown style={{ marginTop: 2 }} />
                    )}
                  </div>
                </Popover>
              </li>
              <li className="nav-list-item">
                <a href="https://www.biniyog.com.bd/learn">Learn</a>
              </li>
              <li className="nav-list-item">
                <a href="https://www.biniyog.com.bd/about">About</a>
              </li>
              <li className="nav-list-item">
                <a href="https://www.biniyog.com.bd/contact">Contact</a>
              </li>

              {hasTranslation ? (
                <li className="nav-list-item">
                  <LanguageToggle style={{ marginBottom: 0 }} />
                </li>
              ) : null}

              <li>
                <a className="link-btn" href="https://platform.biniyog.com.bd/">
                  Login/Register
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
});

const drawerTitleWrapperStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 2px 0px 2px',
};
